import React from 'react';
import {
    BrowserRouter as Router,
    Route,
    Switch,
} from 'react-router-dom';

import Navbar from "./components/Navbar";
import TransitMap from "./components/TransitMap";
import TimetableView from "./components/TimetableView";
import TripPlanner from "./views/TripPlanner";

const App = () => (
    <Router>
        <div>
            <Navbar/>
            <div className="main">
                <TransitMap/>
                <Switch>
                    <Route path="/timetable/:route/:stop" component={TimetableView}/>
                    <Route path="/" component={TripPlanner}/>
                    {/*<Route component={NoMatchView} />*/}
                </Switch>
            </div>
        </div>
    </Router>
);

App.propTypes = {};

export default App;



// WEBPACK FOOTER //
// ./src/App.js